import api from './api';

const otpService = {
  sendOTP: async (data) => {
    return await api.post('/auth/send-otp', data);
  },

  verifyOTP: async (data) => {
    return await api.post('/auth/verify-otp', data);
  },

  resendOTP: async (data) => {
    return await api.post('/auth/resend-otp', data);
  }
};

export default otpService;
